import { Typography } from "@mui/material";
import { ContentColumn } from "../../components/Content";

export default function Services()
{
    return <ContentColumn>
        <Typography>Services</Typography>
    </ContentColumn>
}